import { useState } from "react";
import logo from "../assets/images/ConnerFamilyLogoTree_92x90.png";
import Navbar from "./Navbar";
import Modal from "./Modal";
import { Conner } from "../constants/utilities";

export default function Header() {
  const [showAttendModal, setShowAttendModal] = useState(false);
  const [numAttending, setNumAttending] = useState({});

  const handleShowAttendClick = (e) => {
    Conner.disableBodyScroll();
    Conner.fetchNumAttending(setNumAttending, setShowAttendModal);
  }

  const handleCloseModal = () => {
    Conner.enableBodyScroll();
    setShowAttendModal(false);
  }

  return (
    <>
      <header className="main">
        <div id="banner">
          <div className="banner-inner">
            <div>
              <div className="banner-title"><a href="/">conner family reunion</a></div>
              <div><img id="logoimg" src={logo} alt="Conner family tree logo"/></div>
            </div>
            {/* <div className="banner-title-secondary">connerreunion.com</div> */}
            <button className="btn btn-secondary" onClick={handleShowAttendClick}>Show number attending</button>
          </div>
        </div>
      </header>
      <Navbar />
      {showAttendModal && 
        <Modal
          scope={window}
          contentId="numattendmodal"
          modalClass="modalnumattend"
          isOpen={showAttendModal}
          header={`Number Family Members Attending`}
          showClose={true}
          onClose={handleCloseModal}
          showActiveStatus={false}
          showNoUSMail={false}
          addCheckboxHandler={false}
        >
          <ul className="keyvaluelist">
            <li>
              <div>Attending reunion:</div>
              <div>{numAttending.attend}</div>
            </li>
            <li>
              <div>Attending Saturday meal:</div>
              <div>{numAttending.numsatmeal}</div>
            </li>
            <li>
              <div>Attending Sunday meal:</div>
              <div>{numAttending.numsunmeal}</div>
            </li>
          </ul>
        </Modal>
      }
    </>
  )
}